import React from 'react';
import { ChevronDown } from 'lucide-react';

interface ScrollDownProps {
  targetId: string;
  color?: string;
  size?: number;
}

const ScrollDown: React.FC<ScrollDownProps> = ({ targetId, color = '#ffffff', size = 24 }) => {
  const handleClick = () => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="animate-bounce flex items-center justify-center p-2 rounded-full hover:bg-white/10 transition-colors duration-200"
      style={{ color }}
      aria-label={`Scroll to ${targetId}`}
    >
      <ChevronDown size={size} />
    </button>
  );
};

export default ScrollDown;
